// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5q-6";
export var headerCell = "_5q-2";
export var rowWrapper = "_5q-4";
export var stickyAggregationCell = "_5q-a";
export var stickyAggregationRow = "_5q-7";
export var stickyColumnCell = "_5q-9";
export var stickyColumnHeaderCell = "_5q-8";
export var table = "_5q-1";
export var virtualRowWrapper = "_5q-5";
export var virtualTableContainer = "_5q-0";
export var white = "_5q-3";